import { Component, Input, OnInit } from '@angular/core';
import { ModuleManager } from 'src/shared/models/module-manager';

@Component({
    selector: 'cv-service-level-settings',
    templateUrl: './service-level-settings.component.html',
    styleUrl: './service-level-settings.component.scss'
})
export class ServiceLevelSettingsComponent implements OnInit {
    @Input() moduleManager: ModuleManager;

    selectedMetrics = [339, 340, 350];

    ngOnInit(): void {
        this.moduleManager.customSettingsAdded = true;
    }
}
